import { CanMatchFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {GameService} from "../services/game.service";


export const categoryGuard: CanMatchFn = (route, state) => {

  const requestedCategory = state[1]?.path;
  if(requestedCategory){
    const gameService = inject(GameService);
    const router = inject(Router);

    // const allowedCategories = gameService.categoriesWithGames.map(cat => cat.replace(' ', '')); //todo delete after category refactor
    // console.log(allowedCategories)

    if (gameService.categoriesWithGames.includes(requestedCategory)) {
      // console.log('valid category')
      return true
    }
      //from old react-rival sites there were paths like 'games/rival'
      let providerToNavigate = gameService.providers.find(p => p.routerLink === requestedCategory) //todo rethink - this one checks in initial defaultPublishers when logged in user refreshes the page
      if (providerToNavigate){
        // console.log('valid provider')
        router.navigate(['/providers', requestedCategory])
      } else {
        // console.log('not a valid category or provider, navigate to not found')
        router.navigate(['/not-found']);
      }
  }
  return false






};



